import { Component, Input, OnInit } from '@angular/core';
import { MixedLoyaltyQuery, RewardsWalletItem } from '@fgb/core';
import { Populations } from 'src/app/shared/utilities/populations';

@Component({
  selector: 'fgb-wallet-page',
  templateUrl: './wallet-page.component.html',
  styleUrls: ['./wallet-page.component.scss'],
})
export class WalletPageComponent implements OnInit {
  @Input() walletItems: RewardsWalletItem[];
  populations = Populations;

  constructor(private mixedLoyaltyQuery: MixedLoyaltyQuery) {}

  async ngOnInit() {
    await this.mixedLoyaltyQuery.walletFetch();
  }
}
